let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bLCqV")).then(() => parcelRequire('liS9g'));